module.exports = __webpack_public_path__ + "static/media/menu-fermer.4fb2bb83.svg";